"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
class Message {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    toJSON() {
        return {
            type: this.type,
            value: this.value
        };
    }
}
class ExternalEvent {
    constructor($window, $location, $log, debounce, $rootScope, externalView, XucPhoneState, callContext, CtiProxy, XucUtils) {
        this.$window = $window;
        this.$location = $location;
        this.$log = $log;
        this.debounce = debounce;
        this.$rootScope = $rootScope;
        this.externalView = externalView;
        this.XucPhoneState = XucPhoneState;
        this.callContext = callContext;
        this.CtiProxy = CtiProxy;
        this.XucUtils = XucUtils;
        this.THIRD_PARTY_EVENT_TYPE = 'THIRD_PARTY_EVENT';
        this.PHONE_EVENT_TYPE = 'PHONE_EVENT';
        this.CONFIRM_EVENT_TYPE = 'CONFIRM_QUIT_EVENT';
        this.FULLSCREEN_EVENT_TYPE = 'FULLSCREEN_EVENT';
        this.JITSI_EVENT_TYPE = 'JITSI_EVENT';
        this.WEBHID_INPUT_TYPE = 'WEBHID_INPUT';
        this.WEBHID_DEVICE_SELECTED = 'WEBHID_DEVICE_SELECTED';
        this.WEBHID_LED_OUTPUTS_REPORTS = 'WEBHID_LED_OUTPUTS_REPORTS';
        this.ERROR_TYPE = 'ERROR';
        this.targetLocation = '//' + (this.$location.host() ? this.$location.host() : 'localhost');
        this.thirdPartyCallback = undefined;
        this.confirmQuitCallback = undefined;
        this.fullscreenCallback = undefined;
        this.thirdPartyEvent = { type: this.THIRD_PARTY_EVENT_TYPE, value: {} };
        this.unserializableMessage = new Message(this.ERROR_TYPE, 'Unable to serialize data');
        this.registerEventListener = () => {
            this.$log.info('Register listener for HTML5 API message');
            angular_1.default.element(this.$window).on('message', (event) => {
                this.handleEvent(event.originalEvent || event);
            });
        };
        this.unRegisterEventListener = () => {
            this.$log.info('Unregister listener for HTML5 API message');
            angular_1.default.element(this.$window).off('message', this.registerEventListener);
        };
        this.registerThirdPartyCallback = (cb) => {
            this.thirdPartyCallback = cb;
        };
        this.registerConfirmQuitCallback = (cb) => {
            this.confirmQuitCallback = cb;
        };
        this.registerFullscreenCallback = (cb) => {
            this.fullscreenCallback = cb;
        };
        this.handleEvent = (event) => {
            let data;
            if (angular_1.default.isUndefined(event) || event === null || event.data === null || event.origin === null) {
                this.$log.error('Cannot handle event received, content or origin is empty');
                return;
            }
            if (event.data === "xivo-StartCountDown") {
                return;
            }
            if (event.data === "closeThirdParty") {
                data = this.thirdPartyEvent;
            }
            else {
                if (this.globalKeyEventChecks(event)) {
                    data = event.data;
                }
                else {
                    return;
                }
            }
            var message = this.deserializeData(data);
            switch (message.type) {
                case this.PHONE_EVENT_TYPE:
                    this.handleEventDebounced(message.value);
                    break;
                case this.THIRD_PARTY_EVENT_TYPE:
                    if (this.thirdPartyCallback) {
                        this.thirdPartyCallback();
                    }
                    else {
                        this.$log.error('No callback function is defined for third party event');
                    }
                    break;
                case this.CONFIRM_EVENT_TYPE:
                    if (this.confirmQuitCallback) {
                        this.confirmQuitCallback();
                    }
                    else {
                        this.$log.error('No callback function is defined for quit confirmation');
                    }
                    break;
                case this.FULLSCREEN_EVENT_TYPE:
                    if (this.fullscreenCallback) {
                        this.fullscreenCallback();
                    }
                    else {
                        this.$log.error('No callback function is defined for fullscreen');
                    }
                    break;
                case this.JITSI_EVENT_TYPE:
                    this.$rootScope.$broadcast(this.JITSI_EVENT_TYPE, message.value);
                    break;
                case this.ERROR_TYPE:
                    this.$log.error(message.value);
                    break;
                case this.WEBHID_INPUT_TYPE:
                    this.$rootScope.$broadcast(this.WEBHID_INPUT_TYPE, JSON.parse(message.value));
                    break;
                case this.WEBHID_DEVICE_SELECTED:
                    this.$rootScope.$broadcast(this.WEBHID_DEVICE_SELECTED, message.value);
                    break;
                case this.WEBHID_LED_OUTPUTS_REPORTS:
                    this.$rootScope.$broadcast(this.WEBHID_LED_OUTPUTS_REPORTS, message.value);
                    break;
                default:
                    if (message.type)
                        this.$log.error('Message type from event is not handled by this service', message.type);
            }
        };
        this.triggerAction = (data) => {
            var result = 'External action triggered: ';
            var state = this.XucPhoneState.getState();
            if (data.includes("tel:") || data.includes("callto:")) {
                data = data.replace('tel:', '').replace('callto:', '');
                this.callContext.normalizeDialOrAttTrans(data);
            }
            else {
                if (this.XucPhoneState.isPhoneOffHook(state)) {
                    this.CtiProxy.hangup();
                    result += 'Hangup';
                }
                else if (this.XucPhoneState.isPhoneRinging(state)) {
                    this.CtiProxy.answer();
                    result += 'Answer';
                }
                else {
                    data = this.XucUtils.normalizePhoneNb(data);
                    this.$rootScope.$broadcast("EventShowCallPlaceHolder");
                    this.CtiProxy.dial(data);
                    result += 'Dial ' + data;
                }
            }
            this.$log.info(result);
        };
        this.globalKeyEventChecks = (event) => {
            let eventTargetIsCorrect = this.targetLocation == event.origin.split(':')[1];
            let eventComesFromTheExternalView = this.externalView.getURL() == event.origin.split(':')[1];
            return (eventTargetIsCorrect || eventComesFromTheExternalView);
        };
        this.handleEventDebounced = this.debounce(this.triggerAction);
        this.deserializeData = (data) => {
            try {
                let item = angular_1.default.fromJson(data);
                return new Message(item.type, item.value);
            }
            catch (exception) {
                var message = this.unserializableMessage;
                message.value += data;
                return message;
            }
        };
        this.registerEventListener();
    }
}
exports.default = ExternalEvent;
ExternalEvent.$inject = ['$window', '$location', '$log', 'debounce', '$rootScope', 'externalView', 'XucPhoneState', 'callContext', 'CtiProxy', 'XucUtils'];
